import React from 'react'
import createReactClass from 'create-react-class'
import ErrorBlock from '../../elements/error-block'

export default createReactClass({

  getErrorMessage (error) {
    return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  buildSelectOptions (value) {
    return value.dropdownDetails.map((item, index) => {
      return <option key={index} value={item.label}>{item.label}</option>
    })
  },

  buildFormItem (index, value) {
    const element = <div className="row margin-bottom-10" key={index}>
      <div className="col-xs-6">
        <label className="user-field-label" htmlFor={value.paramName}>{value.label}</label>
      </div>
      <div className="col-xs-6">
        {value.fieldType.toLowerCase() === 'dropdown'
          ? <div className="select-wrapper">
            <select className="decision-tree-select"
              name={value.paramName}
              id={value.paramName}
              mandatory={value.mandatory ? 'true' : 'true'}
              onChange={(event) => this.handleChange(event, value.paramName)}>
              <option value=''>Select...</option>
              {this.buildSelectOptions(value)}
            </select>
          </div>
          : <input className="decision-tree-input" name={value.paramName} id={value.paramName} type={value.fieldType === 'Integer' ? 'number' : 'text'} mandatory={value.mandatory ? 'true' : 'false'}
            onChange={(event) => this.handleChange(event, value.paramName)}/>}
      </div>
    </div>
    return element
  },

  buildDecisionTreeUserFields (labels) {
    const items = []
    if (labels && Object.keys(labels).length > 0) {
      for (const [index, value] of labels.fields.entries()) {
        items.push(this.buildFormItem(index, value))
      }
    }

    return items
  },

  handleChange (event, key) {
    this.props.handleFormInputChange(event, key)
  },

  renderUserDataFields () {
    if (this.props.error) {
      return (<div>
        <h4>Decision Tree</h4>
        <ErrorBlock {...this.props.error}/>
      </div>)
    }
    if (this.props.selectedTree.GUID) {
      if (this.props.userLoader) {
        return (
          <div className="section-body clearfix">
            <div className='loader-ctr'><span className="loading"></span></div>
          </div>
        )
      }
      if (this.props.userError) {
        return (
          <div className="section-body clearfix">
            <ErrorBlock {...this.props.userError}/>
          </div>
        )
      } else {
        return (
          <div>
            {this.buildDecisionTreeUserFields(this.props.decisionTreeUserFields)}
          </div>
        )
      }
    }
    return null
  },

  render () {
    return (
      <div className="decision-tree-user-fields">
        {this.renderUserDataFields()}
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/report-page/decision-tree-user-fields-panel.js